// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListGridCoverPhoto-leftBanner-Pz3hW {
	height: 500px !important;
	overflow: hidden;
	border-radius: 15px;
	background-color: var(--secondary-gray-bg);
}

.ListGridCoverPhoto-pad0-D2WQy {
	padding: 0 !important;
}

/* .bgbanner {
	transform: scale(1) !important;
	transition: -ms-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, -webkit-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, opacity 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s !important;
}
.bgbanner:hover {
	transform: scale(1.05) !important;
	transition: -ms-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, -webkit-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s !important;
} */

.ListGridCoverPhoto-gridTwo-eAJ9b {
	display: grid;
	grid-template-columns: 50% 50%;
	grid-gap: 10px;
}

.ListGridCoverPhoto-bgBannerTwo-reEhc {
	min-height: 245px;
}

.ListGridCoverPhoto-bannerBottom-I59Nk {
	margin-bottom: 10px;
}

.ListGridCoverPhoto-leftBorderRadius-lS583 {
	border-top-left-radius: 15px;
	border-bottom-left-radius: 15px;
}

.ListGridCoverPhoto-rightBorderRadius-FffBW {
	border-top-right-radius: 15px;
	border-bottom-right-radius: 15px;
}

.ListGridCoverPhoto-rightBorderTopRadius-RN3s1 {
	border-top-right-radius: 15px;
}

.ListGridCoverPhoto-rightBorderBottomRadius-fBU2d {
	border-bottom-right-radius: 15px;
}

@media (min-width: 320px) and (max-width: 767px) {
	.ListGridCoverPhoto-hiddenxs-qWZ3K {
		display: none;
	}

	.ListGridCoverPhoto-leftBanner-Pz3hW {
		width: 100% !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/ListGridCoverPhoto/ListGridCoverPhoto.css"],"names":[],"mappings":"AAAA;CACC,wBAAwB;CACxB,gBAAgB;CAChB,mBAAmB;CACnB,0CAA0C;AAC3C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;;;;;;GAOG;;AACH;CACC,aAAa;CACb,8BAA8B;CAC9B,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,+BAA+B;AAChC;;AAEA;CACC,6BAA6B;CAC7B,gCAAgC;AACjC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC;EACC,aAAa;CACd;;CAEA;EACC,sBAAsB;CACvB;AACD","sourcesContent":[".leftBanner {\n\theight: 500px !important;\n\toverflow: hidden;\n\tborder-radius: 15px;\n\tbackground-color: var(--secondary-gray-bg);\n}\n\n.pad0 {\n\tpadding: 0 !important;\n}\n\n/* .bgbanner {\n\ttransform: scale(1) !important;\n\ttransition: -ms-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, -webkit-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, opacity 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s !important;\n}\n.bgbanner:hover {\n\ttransform: scale(1.05) !important;\n\ttransition: -ms-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, -webkit-transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s, transform 450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s !important;\n} */\n.gridTwo {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tgrid-gap: 10px;\n}\n\n.bgBannerTwo {\n\tmin-height: 245px;\n}\n\n.bannerBottom {\n\tmargin-bottom: 10px;\n}\n\n.leftBorderRadius {\n\tborder-top-left-radius: 15px;\n\tborder-bottom-left-radius: 15px;\n}\n\n.rightBorderRadius {\n\tborder-top-right-radius: 15px;\n\tborder-bottom-right-radius: 15px;\n}\n\n.rightBorderTopRadius {\n\tborder-top-right-radius: 15px;\n}\n\n.rightBorderBottomRadius {\n\tborder-bottom-right-radius: 15px;\n}\n\n@media (min-width: 320px) and (max-width: 767px) {\n\t.hiddenxs {\n\t\tdisplay: none;\n\t}\n\n\t.leftBanner {\n\t\twidth: 100% !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftBanner": `ListGridCoverPhoto-leftBanner-Pz3hW`,
	"pad0": `ListGridCoverPhoto-pad0-D2WQy`,
	"gridTwo": `ListGridCoverPhoto-gridTwo-eAJ9b`,
	"bgBannerTwo": `ListGridCoverPhoto-bgBannerTwo-reEhc`,
	"bannerBottom": `ListGridCoverPhoto-bannerBottom-I59Nk`,
	"leftBorderRadius": `ListGridCoverPhoto-leftBorderRadius-lS583`,
	"rightBorderRadius": `ListGridCoverPhoto-rightBorderRadius-FffBW`,
	"rightBorderTopRadius": `ListGridCoverPhoto-rightBorderTopRadius-RN3s1`,
	"rightBorderBottomRadius": `ListGridCoverPhoto-rightBorderBottomRadius-fBU2d`,
	"hiddenxs": `ListGridCoverPhoto-hiddenxs-qWZ3K`
};
module.exports = ___CSS_LOADER_EXPORT___;
